var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      !_vm.waitingForFinish
        ? _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("save-to")))]),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-card-content" } },
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _c("h3", [
                          _c("span", { staticClass: "step" }, [_vm._v("1")]),
                          _vm._v(
                            " " + _vm._s(_vm.$ct("source-documents")) + " "
                          ),
                        ]),
                      ]),
                      _vm.selectedItems.length == 0
                        ? [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("app-sale-type-select", {
                                  attrs: {
                                    "use-id": "",
                                    "contact-group-id": _vm.contactGroupId,
                                  },
                                  model: {
                                    value: _vm.data.OriginalDocTypeID,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.data,
                                        "OriginalDocTypeID",
                                        $$v
                                      )
                                    },
                                    expression: "data.OriginalDocTypeID",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "6" } },
                              [
                                _c("w-date-picker", {
                                  attrs: {
                                    label: _vm.$ct("common.from"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.data.FromDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.data, "FromDate", $$v)
                                    },
                                    expression: "data.FromDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "6" } },
                              [
                                _c("w-date-picker", {
                                  attrs: {
                                    label: _vm.$ct("common.till"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.data.TillDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.data, "TillDate", $$v)
                                    },
                                    expression: "data.TillDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("app-contact-search-with-browse-by-id", {
                                  attrs: {
                                    label: _vm.contactGroupName,
                                    "group-id": _vm.contactGroupId,
                                    fancy: "",
                                    "icon-left": "times",
                                  },
                                  on: {
                                    "icon-left-click": function ($event) {
                                      _vm.data.ContactID = 0
                                    },
                                  },
                                  model: {
                                    value: _vm.data.ContactID,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.data, "ContactID", $$v)
                                    },
                                    expression: "data.ContactID",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _c("w-col", { attrs: { xs: "12" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$ctc(
                                    "save-to-selected-documents",
                                    _vm.selectedItems.length
                                  )
                                ) +
                                " "
                            ),
                          ]),
                    ],
                    2
                  ),
                  _c(
                    "w-row",
                    { staticClass: "mt" },
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _c("h3", [
                          _c("span", { staticClass: "step" }, [_vm._v("2")]),
                          _vm._v(
                            " " + _vm._s(_vm.$ct("target-documents")) + " "
                          ),
                        ]),
                      ]),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-sale-type-select", {
                            attrs: {
                              "use-id": "",
                              "contact-group-id": _vm.contactGroupId,
                            },
                            model: {
                              value: _vm.data.TargetDocumentTypeID,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "TargetDocumentTypeID", $$v)
                              },
                              expression: "data.TargetDocumentTypeID",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-date-picker", {
                            attrs: { label: _vm.$ct("date-start"), fancy: "" },
                            model: {
                              value: _vm.data.TargetDocumentDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "TargetDocumentDate", $$v)
                              },
                              expression: "data.TargetDocumentDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("transfer-payments-to-new-docs"),
                            },
                            model: {
                              value: _vm.data.TransferPaymentsToNewDocs,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data,
                                  "TransferPaymentsToNewDocs",
                                  $$v
                                )
                              },
                              expression: "data.TransferPaymentsToNewDocs",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("send-via-peppol"),
                              disabled: !_vm.canSendPeppol,
                            },
                            model: {
                              value: _vm.data.SendViaPeppol,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "SendViaPeppol", $$v)
                              },
                              expression: "data.SendViaPeppol",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: _vm.mailModeOn,
                              label: _vm.$ct("mail-documents"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setMailModeOn($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            staticClass: "sub-checkbox",
                            attrs: {
                              disabled: !_vm.mailModeOn,
                              value: _vm.mailModeOnlyIfNoPeppol,
                              label: _vm.$ct(
                                "only-mail-if-client-has-no-peppol"
                              ),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setMailModeOnlyIfNoPeppol($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: _vm.printModeOn,
                              label: _vm.$ct("print-documents"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setPrintModeOn($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            staticClass: "sub-checkbox",
                            attrs: {
                              disabled: !_vm.printModeOn || !_vm.mailModeOn,
                              value: _vm.printModeOnlyIfNoMail,
                              label: _vm.$ct(
                                "only-print-if-client-has-no-email"
                              ),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setPrintDocumentModeIfNoMail($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("add-imported-from-sale-text"),
                            },
                            model: {
                              value: _vm.data.AddImportedFromSaleText,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data,
                                  "AddImportedFromSaleText",
                                  $$v
                                )
                              },
                              expression: "data.AddImportedFromSaleText",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.isSending, icon: "check" },
                      on: {
                        click: function ($event) {
                          return _vm.confirm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-card",
            { attrs: { "max-width": "300" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("save-to")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$ct("documents-are-being-created")) +
                            " "
                        ),
                      ]),
                      _c(
                        "w-col",
                        { staticClass: "mt", attrs: { xs: "12", center: "" } },
                        [_c("w-progress-circular", { attrs: { large: "" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }